'use client';
import { useState } from 'react';
import BurgerMenu from '../icons/burger-menu';
import SideMenu from '@/layout/side-menu';

const SideMenuButton = () => {
  const [side, setSide] = useState(false);
  return (
    <>
      <button onClick={() => setSide(true)} aria-label='Open side menu'>
        <BurgerMenu className='size-[15px] max-md:min-h-7 max-md:min-w-6 max-sm:min-h-5 max-sm:min-w-5' />
      </button>
      {side ? <SideMenu setSide={setSide} /> : null}
    </>
  );
};

export default SideMenuButton;
